<template>
    <div>
        <div style="padding-top: 20px">
            <el-select v-model="type">
                <el-option
                        v-for="item of typeOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"/>
            </el-select>
            <div class="common-search">
                <el-input
                        v-model="searchVal"
                        class="common-el-input"
                        placeholder="请输入昵称或ID查询"/>
                <el-button type="primary" @click="getList()">搜索</el-button>
            </div>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="exceptionList.beanList" height="100%" row-key="id">
                <el-table-column align="center" label="编号" type="index"/>
                <el-table-column align="center" min-width="120" label="昵称" prop="username"/>
                <el-table-column align="center" min-width="110" label="ID" prop="userRandomId"/>
                <el-table-column align="center" min-width="140" label="异常场景">
                    <template slot-scope="scope">{{scope.row.type | typeName}}</template>
                </el-table-column>
                <el-table-column align="center" min-width="150" label="记录时间" prop="createTime"/>
                <el-table-column align="center" label="处理状态">
                    <template slot-scope="scope">{{scope.row.status?'已处理':'未处理'}}</template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button :disabled="Boolean(scope.row.status)" size="mini" type="primary"
                                   @click="updateStatusFunc(scope.row.id)">标记为已处理
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="200" label="操作记录">
                    <span v-show="!!scope.row.updateTime" slot-scope="scope">{{scope.row.updateTime}} 已处理</span>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :currentPage="currentPage"
                @current-change="getList($event)"
                :total="exceptionList.total"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        components: {},
        data() {
            return {
                loading: false,
                searchVal:'',
                type: -1,
                typeOptions: [
                    {label: '全部', value: -1},
                    {label: '未处理', value: 0},
                    {label: '已处理', value: 1}
                ],
                currentPage: 1
            }
        },
        computed: {
            ...mapState('audit', ['exceptionList']),
        },
        filters: {
            typeName(type) {
                let arr = ['转豆', '提豆', '俱乐部充值','发放基金','牌局带入 '];
                return arr[type - 1];
            }
        },
        methods: {
            ...mapActions('audit', ['getExceptionList', 'updateExceptionRecord']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getExceptionList({
                    page,
                    type: this.type,
                    key:this.searchVal
                }).then(() => {
                    this.loading = false
                })
            },
            updateStatusFunc(id) {
                this.$confirm('是否标记为已经人工处理', '提示', {
                    type: 'info'
                }).then(() => {
                    this.updateExceptionRecord({
                        id,
                        type: 1
                    }).then(() => {
                        this.$message.success('请求成功');
                        this.getList(this.currentPage)
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
